import React, { useState, useEffect, useMemo } from "react";
import { VsiBubble } from "../styled/App.styled";
import { useDataWithRoute } from "../utils/hooks";
import Stockchart from "../components/Stockchart";
import { formatStockChartConfig } from "../utils/Helpers";
import { Spinner } from "reactstrap";
import { useVsiAppContext } from "../stores/VsiApp";

const chartConfig = {
  yAxis: [
    {
      title: {
        text: "GiB"
      }
    }
  ]
};

export default function BackupTrend() {
  const { client: { clientId } } = useVsiAppContext();

  const route = useMemo(() => `/api/v6/report/enterprise_backup_trend_proc?client_id=${clientId}`, [clientId]);
  const [{ recordset }, { isLoading }] = useDataWithRoute(route);

  const trendData = useMemo(() => {
    const config = formatStockChartConfig(recordset, [
      {
        name: "Used",
        field: "used"
      },
      {
        name: "Free",
        field: "free"
      },
      {
        name: "Usable",
        field: "usable"
      }
      // no allocated in original trend, why was it here and why was it hardcoded?
    ]);

    return config.series;
  }, [recordset]);

  return isLoading ? (
    <Spinner color={"success"} />
  ) : (
    <VsiBubble>
      <Stockchart series={trendData}
                  config={chartConfig}
                  height={420}
                  navDisabled={true}
                  disableLegend={true} />
    </VsiBubble>
  );
}